/** Rotas do shell referenciadas em mais de um lugar. */
export const LOGIN_PATH = "/login";
/** Public registration and landing-page conversion destination. */
export const SIGN_UP_PATH = "/cadastro";
/** Primeiro acesso (senha provisória) e troca voluntária de senha. */
export const CHANGE_PASSWORD_PATH = "/change-password";
